import outfitImg from "./outfitImg.png";
import "./styles.css";

export default function Outfit() {
  return (
    <section className="outfit-section">
      <h2 className="outfit-title">CÓDIGO DE VESTIMENTA</h2>
      <p className="outfit-subtitle">Formal</p>

      <img
        src={outfitImg}
        alt="Código de vestimenta formal"
        className="outfit-icon"
      />

      <p className="outfit-text">
        Con mucho cariño, les pedimos evitar prendas en color verde y blanco.
      </p>
    </section>
  );
}